@if (item.show) {
  <div class="group-title">
    <span class="hint-text">{{ item.title | translate }}</span>
  </div>
  <div class="group-items">
    @for (item of item.children; track item) {
      @if (item.type=='group') {
        <fuse-nav-vertical-group [item]="item"></fuse-nav-vertical-group>
      }
      @if (item.type=='collapse') {
        <fuse-nav-vertical-collapse [item]="item"></fuse-nav-vertical-collapse>
      }
      @if (item.type=='item') {
        <fuse-nav-vertical-item [item]="item"></fuse-nav-vertical-item>
      }
    }
  </div>
}
